import axios from '@/axios/index'

// 内容分析接口
export function getContentAnalysis(data) {
  return axios({
    url: '/api/banner/mass/content/analyze',
    method: 'post',
    data
  })
}

// 排序指标
export function getSortLabel() {
  return axios({
    url: '/api/label/data/index/label',
    method: 'get'
  })
}

// 产线分析列表
export function getList(data) {
  return axios({
    url: '/api/banner/mass/content/list',
    method: 'post',
    data
  })
}

// 产线分析总数
export function getListTotal(data) {
  return axios({
    url: '/api/banner/mass/content/list/total',
    method: 'post',
    data
  })
}

// 导出
export function getExportLabel(data = {}) {
  return axios({
    url: '/api/label/article/export/label',
    method: 'get',
    data
  })
}
